/**
 * Леттеринг «ВОЛАН»: чистый дисплейный текст, как в референсе (без
 * декоративного волана и росчерка — там жирный блочный заголовок и ничего
 * больше). Шрифт берётся из документа (inline-SVG видит @font-face), поэтому
 * логотип — не картинка, а текст: читается скринридером через aria-label у h1.
 */
export default function Logo({ width = 230 }: { width?: number }) {
  return (
    <svg
      viewBox="0 10 252 92"
      width={width}
      role="presentation"
      aria-hidden="true"
      focusable="false"
    >
      <text
        x="10"
        y="74"
        fontFamily="'Russo One', 'Manrope', sans-serif"
        fontSize="58"
        letterSpacing="4"
        fill="#16324f"
      >
        ВОЛАН
      </text>
    </svg>
  )
}
